<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="itemTypesService"
    [idKey]="'itemTypeId'"
></base-index-page>